@if (productCode) {
  <form [formGroup]="addToCartForm">
    <udx-product-summary></udx-product-summary>
    <div class="container">
      <label class="label-font">{{ 'pdp.selectQuantity' | cxTranslate }}</label>
      @for (option of product?.variantOptions; track option) {
        <div class="row mt-3">
          <div class="col grp-product-name">{{ option.name }}:</div>
          <div class="col-lg-2 grp-product-price">{{ option.startingPrice?.formattedValue }}</div>
          <div class="col-lg-6">
            <app-item-counter
              [control]="$any(addToCartForm.get(option.code!))"
              (quantityChanged)="onGroupRuleQuantityChange($event, option.code!)"
            ></app-item-counter>
            @if (stepperBtnDisabled(option.stock)) {
              <small class="text-danger out-of-stock-label">{{ 'addToCart.outOfStock' | cxTranslate }}</small>
            }
          </div>
        </div>
      }
    </div>
  </form>
}
